<div class="row g-4 mb-3">
  <div class="col-sm-auto">
    <div>
      <button type="button" (click)="openModal('create')" class="btn btn-success add-btn me-1">
        <i class="ri-add-line align-bottom me-1"></i> Invite User </button>
      </div>
    </div>
    <div class="col-sm">
      <div class="d-flex justify-content-sm-end">
        <div class="search-box ms-2">
          <input type="text" class="form-control search" placeholder="Search..." [(ngModel)]="searchText" (input)="onSearch()">
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive table-card mt-3 mb-1">
    <table class="table">
      <thead>
        <tr class="bg-light text-muted">
          <th class="sort" listsortable="first_name" (listsort)="onSort($event)">First Name</th>
          <th class="sort" listsortable="last_name" (listsort)="onSort($event)">Last Name</th>
          <th class="sort" listsortable="email" (listsort)="onSort($event)">Email</th>
          <th>Roles</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td colspan="6" class="text-center">
              <app-loading-spinner></app-loading-spinner>
            </td>
          </tr>
        }
        @if (!loading && users && users.length > 0) {
          @for (client_user of users; track client_user) {
            <tr>
              <td>
                <ngb-highlight [result]="client_user.user.person.first_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="client_user.user.person.last_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="client_user.user.email" [term]="searchText"></ngb-highlight>
              </td>
              <td class="status">
                @for (role of client_user.roles; track role) {
                  <span
                    class="badge text-uppercase me-1"
                    [ngClass]="role === 'ADMIN' ? 'bg-danger-subtle text-danger' : role === 'EDITOR' ? 'bg-warning-subtle text-warning' : 'bg-success-subtle text-success'">
                    {{ role }}
                  </span>
                }
              </td>
              <td class="status">
                <span
                  class="badge text-uppercase"
                  [ngClass]="client_user.status === 'ACTIVE' ? 'bg-success-subtle text-success' : client_user.status === 'SUSPENDED'? 'bg-danger-subtle text-danger':'bg-warning-subtle text-warning'">
                  {{ client_user.status }}
                </span>
              </td>
              <td>
                @if (currentUser?.id !== client_user.user.id) {
                  <div class="d-flex gap-2">
                    <button (click)="openModal('edit', client_user)" class="btn btn-sm btn-info edit-item-btn" ngbTooltip="Edit User" alt="Edit User">
                      <i class="ri-pencil-line align-middle"></i>
                    </button>
                    <div class="remove">
                      <button (click)="openModal('remove', client_user)" class="btn btn-sm btn-danger remove-item-btn" ngbTooltip="Remove User" alt="Remove User">
                        <i class="ri-delete-bin-line align-middle"></i>
                      </button>
                    </div>
                    <div class="edit">
                      <button (click)="openModal(client_user.status === 'SUSPENDED' ? 'activate' : 'suspend', client_user)" class="btn btn-sm remove-item-btn" [ngClass]="client_user.status === 'SUSPENDED' ? 'btn-success' : 'btn-warning'" [ngbTooltip]="client_user.status === 'SUSPENDED' ? 'Activate User' : 'Suspend User'" alt="client_user.status === 'SUSPENDED' ? 'Activate User' : 'Suspend User'">
                        <i class="align-middle" [ngClass]="client_user.status === 'SUSPENDED' ? 'ri-lock-unlock-line' : 'ri-lock-line'"></i>
                      </button>
                    </div>
                    @if (client_user.status === 'INVITED') {
                      <div class="edit">
                        <button (click)="openModal('invite', client_user)" class="btn btn-sm btn-secondary remove-item-btn" ngbTooltip="ReInvite User" alt="ReInvite User">
                          <i class="ri-refresh-line align-middle"></i>
                        </button>
                      </div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        }
        @if (!loading && users && users.length === 0) {
          <tr>
            <td colspan="6" class="text-center">No users found.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!loading && users && users.length > 0) {
    <div class="row justify-content-md-between align-items-md-center">
      <div class="col col-sm-6">
        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalUsers}} entries </div>
      </div>
      <div class="col col-sm-6">
        <div class="text-sm-right float-end listjs-pagination">
          <ngb-pagination [collectionSize]="totalUsers" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getUsers()"></ngb-pagination>
        </div>
      </div>
    </div>
  }

  <app-create-user #createUser (userChanged)="refreshUsers()"></app-create-user>